(() => {
  if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }
  }, { threshold: 0.08, rootMargin: '0px 0px 40px 0px' });

  const observe = (root = document) => {
    for (const item of root.querySelectorAll('.wood-page[data-wood-reveal]:not(.is-visible)')) observer.observe(item);
  };

  observe();
  document.documentElement.classList.add('wood-motion-ready');
  document.addEventListener('shopify:section:load', (event) => observe(event.target));
})();
